import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from './sidebar.service';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  public selected1 = {};
  public selected2 = {};
  public selected3 = {};
  public selected3a = {};
  public selected3b = {};
  public selected3c = {};
  public selected4 = {};
  public selected4a = {};
  public selected4b = {};
  public selected4c = {};
  public selected4d = {};
  public selected5 = {};
  public selected5a = {};
  public selected6 = {};
  public selected6a = {};
  public selected7 = {};
  public selected7a = {};
  public selected7b = {};
  public selected7c = {};
  public selected7d = {};
  public selected8 = {};
  public selected9 = {};
  public selected10 = {};
  public selected11 = {};
  public selected11a = {};
  public selected11b = {};
  public selected11c = {}; 
  public selected12 = {}; 
  public selected13 = {}; 
  public clickedEvent1: Event;
  public clickedEvent2: Event;
  public clickedEvent3: Event;
  public clickedEvent3a: Event;
  public clickedEvent3b: Event;
  public clickedEvent3c: Event;
  public clickedEvent4: Event;
  public clickedEvent4a: Event;
  public clickedEvent4b: Event;
  public clickedEvent4c: Event;
  public clickedEvent4d: Event;
  public clickedEvent5: Event;
  public clickedEvent5a: Event;
  public clickedEvent6: Event;
  public clickedEvent6a: Event;
  public clickedEvent7: Event;
  public clickedEvent7a: Event;
  public clickedEvent7b: Event;
  public clickedEvent7c: Event;
  public clickedEvent7d: Event;
  public clickedEvent8: Event;
  public clickedEvent9: Event;
  public clickedEvent10: Event;
  public clickedEvent11: Event;
  public clickedEvent11a: Event;
  public clickedEvent11b: Event;
  public clickedEvent11c: Event;
  public clickedEvent12: Event;
  public clickedEvent13: Event;

  @ViewChild('sidebar') public sidebar: MatDrawer;

  constructor(public router: Router,
              public route: ActivatedRoute,
              public sidebarService: SidebarService){}


  ngOnInit(): void {
    this.sidebarService.setSidenav(this.sidebar);
  }

  childEventClicked1(selected1: Event) {
    this.clickedEvent1 = selected1;
  }

  childEventClicked2(selected2: Event) {
    this.clickedEvent2 = selected2;
  }

  childEventClicked3(selected3: Event) {
    this.clickedEvent3 = selected3;
  }

  childEventClicked3a(selected3a: Event) {
    this.clickedEvent3a = selected3a;
  }

  childEventClicked3b(selected3b: Event) {
    this.clickedEvent3b = selected3b;
  }

  childEventClicked3c(selected3c: Event) {
    this.clickedEvent3c = selected3c;
  }

  childEventClicked4(selected4: Event) {
    this.clickedEvent4 = selected4;
  }

  childEventClicked4a(selected4a: Event) {
    this.clickedEvent4a = selected4a;
  }

  childEventClicked4b(selected4b: Event) {
    this.clickedEvent4b = selected4b;
  }

  childEventClicked4c(selected4c: Event) {
    this.clickedEvent4c = selected4c;
  }

  childEventClicked4d(selected4d: Event) {
    this.clickedEvent4d = selected4d;
  }

  childEventClicked5(selected5: Event) {
    this.clickedEvent5 = selected5;
  }

  childEventClicked5a(selected5a: Event) {
    this.clickedEvent5a = selected5a;
  }

  childEventClicked6(selected6: Event) {
    this.clickedEvent6 = selected6;
  }

  childEventClicked6a(selected6a: Event) {
    this.clickedEvent6a = selected6a;
  }

  childEventClicked7(selected7: Event) {
    this.clickedEvent7 = selected7;
  }

  childEventClicked7a(selected7a: Event) {
    this.clickedEvent7a = selected7a;
  }

  childEventClicked7b(selected7b: Event) {
    this.clickedEvent7b = selected7b;
  }

  childEventClicked7c(selected7c: Event) {
    this.clickedEvent7c = selected7c;
  }

  childEventClicked7d(selected7d: Event) {
    this.clickedEvent7d = selected7d;
  }

  childEventClicked8(selected8: Event) {
    this.clickedEvent8 = selected8;
  }

  childEventClicked9(selected9: Event) {
    this.clickedEvent9 = selected9;
  }

  childEventClicked10(selected10: Event) {
    this.clickedEvent10 = selected10;
  }

  childEventClicked11(selected11: Event) {
    this.clickedEvent11 = selected11;
  }

  childEventClicked11a(selected11a: Event) {
    this.clickedEvent11a = selected11a;
  }

  childEventClicked11b(selected11b: Event) {
    this.clickedEvent11b = selected11b;
  }

  childEventClicked11c(selected11c: Event) {
    this.clickedEvent11c = selected11c;
  }

  childEventClicked12(selected12: Event) {
    this.clickedEvent12 = selected12;
  }

  childEventClicked13(selected13: Event){
    this.clickedEvent13 = selected13;
  }
}
